import React from 'react'
import { FourSquare, Mosaic } from 'react-loading-indicators'

const Loader = () => {
  return (
    <div className='flex justify-center items-center h-screen'>
      <FourSquare color="#dc2626" size="medium" text="Loading..." textColor="#dc2626" />
    </div>
  )
}

export default Loader